import React, { Component } from "react";
import { connect } from "react-redux";

import { doGetDisclaimers, doGetChannelGroups, doGetAllSSGChannelGroups, doGetUsers } from "../../../../actions/lists";
import { doRemoveDisclaimer } from "../../../../actions/deletes";
import { getFriendlyDate } from "../../../../utils/Helpers";
import ElementListBox, { PaginationData } from "../../../molecules/ElementListBox";
import { Wrapper, Row } from "../../../atoms/Layout";
import { doGetClients } from "../../../../actions";

interface ListFilters {
    search?: string;
    cid?: string;
    channelGroups?: string;
}
class DisclaimerView extends Component<
    { clients: { [cid: string]: Mongo.IClient }; user: Mongo.clientAdmin },
    { filters: ListFilters; paginationData: PaginationData; channelGroupsList: string[]; allClients?: Mongo.IClient[] }
> {
    static allowSuper = true;
    static allowApiAdmin = false;
    static allowClientAdmin = true;
    static allowSuperClientAdmin = true;
    static allowAdmin = false;
    static allowCurator = false;
    static allowReports = false;

    constructor(props) {
        super(props);
        this._refresh = this._refresh.bind(this);
        this.state = {
            paginationData: {
                limit: 20,
                skip: 0
            },
            filters: {
                search: "",
                cid: props.user ? props.user.cid || "" : "",
                channelGroups: ""
            },
            channelGroupsList: []
        };
        if (!this.props.user.isSuper) {
            doGetChannelGroups(props.user?.cid).then(data => {
                this.setState({ channelGroupsList: data });
            });
        } else {
            doGetClients().then(allClients => {
                this.setState({ allClients });
            });
            doGetAllSSGChannelGroups("ssg").then(data => {
                this.setState({ channelGroupsList: data });
            });
        }
    }

    _prepareFilterData(filters: ListFilters) {
        const { search, channelGroups, cid } = filters;
        return {
            ...(search ? { search } : null),
            ...(cid ? { cid } : null),
            ...(channelGroups ? { channelGroups: { $in: [channelGroups] } } : null)
        };
    }

    _getClientName(cid: string) {
        const { clients } = this.props;
        if (cid) {
            if (clients && clients[cid]) {
                return clients[cid].name;
            } else if (clients && Object.keys(clients).length) {
                return "REMOVED";
            }
            return "Loading...";
        }
        return "None";
    }

    _refresh(filters: ListFilters, paginationData: PaginationData) {
        if (!filters) {
            filters = this.state.filters || {};
        }
        if (!this.props.user.isSuper) {
            filters.cid = this.props.user.cid!;
        }
        if (!paginationData) {
            paginationData = this.state.paginationData;
        }
        return doGetDisclaimers({ ...this._prepareFilterData(filters), ...paginationData });
    }

    async delete(disclaimer: Mongo.IDisclaimer) {
        let channelGroups = disclaimer.channelGroups;
        if (channelGroups.indexOf("All Channels") > -1) {
            channelGroups = this.state.channelGroupsList;
        }
        const userCount = (await doGetUsers({ channelGroups, skip: 0, limit: 0 })).total;
        if (
            confirm(
                `Are you sure you want to delete ${disclaimer.name}? This will affect the profiles of ${userCount} users. The disclaimer will be removed the next time the user updates their profile.`
            )
        ) {
            return doRemoveDisclaimer(disclaimer.did);
        }
        return false;
    }

    render() {
        const { channelGroupsList } = this.state;
        const { user } = this.props;
        const ssgClients = this.state.allClients?.filter(client => client.compliance?.vendor === "ssg");
        return (
            <Wrapper>
                <Row>
                    <ElementListBox<Mongo.IDisclaimer>
                        title="Disclaimers"
                        createLink={
                            user.isSuper || user.isSuperClientAdmin || user.isClientAdmin ? "/disclaimer/c" : undefined
                        }
                        editLink={"/disclaimer/e/:did"}
                        filters={{
                            ...(user.isSuper
                                ? {
                                    cid: {
                                        title: "Filter By Clients",
                                        options: [
                                            { key: "All", value: "" },
                                            ...(ssgClients || []).map(data => ({ key: data.name, value: data.cid }))
                                        ]
                                    }
                                }
                                : null),
                            channelGroups: {
                                title: "Filter By Channel Groups",
                                options: [
                                    { key: "All", value: "" },
                                    ...channelGroupsList.map(data => {
                                        return { key: data, value: data };
                                    })
                                ]
                            }
                        }}
                        refresh={({ search, cid, channelGroups }, paginationData) =>
                            this._refresh({ search, cid, channelGroups }, paginationData)
                        }
                        keys={{
                            name: "Name",
                            ...(user.isSuper ? {client: "Client"} : null),
                            channelGroups: "Channel Groups",
                            date_created: "Last Updated",
                            actions: "Actions"
                        }}
                        sortableKeys={["Name", "Last Updated"]}
                        defaultSort={{ name: -1 }}
                        mutateItem={disclaimer => ({
                            name: disclaimer.name,
                            client: user.isSuper ? this._getClientName(disclaimer.cid) : "",
                            channelGroups: disclaimer.channelGroups.join(", "),
                            date_created: getFriendlyDate(disclaimer.date_created) || <span>N/A</span>
                        })}
                        delete={
                            user.isSuper || user.isSuperClientAdmin || user.isClientAdmin
                                ? item => this.delete(item)
                                : undefined
                        }
                    />
                </Row>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    clients: state.lists.clients,
    user: state.session.admin
});

export default connect(mapStateToProps)(DisclaimerView);
